import React from 'react';
import { MessageCircleOff, BrainCircuit, HeartCrack, AlertTriangle } from 'lucide-react';
import { Button } from './Button';
export function PainPoints() {
  return <section className="py-6 md:py-8 px-3 md:px-4 bg-black" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <div className="text-center mb-8" data-id="element-177">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-178">
            Si estás esperando un mensaje que no llega…{' '}
            <span className="text-rosa" data-id="element-179">esto es para vos</span>
          </h2>
          <p className="text-lg text-gray-400 italic" data-id="element-180">
            Porque en el fondo ya lo sabés: te estás{' '}
            <strong className="text-gray-200" data-id="element-181">
              perdiendo por alguien que no te elige
            </strong>
          </p>
        </div>

        <div className="grid gap-3 mb-8" data-id="element-182">
          <div className="bg-dark p-4 rounded-xl border border-white/5 flex items-start gap-4" data-id="element-183">
            <MessageCircleOff className="text-terracota shrink-0 mt-1" data-id="element-184" />
            <p className="text-gray-200" data-id="element-185">
              Te dijiste que{' '}
              <strong className="text-white" data-id="element-186">no le ibas a escribir más</strong>
            </p>
          </div>
          <div className="bg-dark p-4 rounded-xl border border-white/5 flex items-start gap-4" data-id="element-187">
            <BrainCircuit className="text-terracota shrink-0 mt-1" data-id="element-188" />
            <p className="text-gray-200" data-id="element-189">
              Intentás hacerte la fuerte pero{' '}
              <strong className="text-white" data-id="element-190">empezás a sobrepensar todo</strong>
            </p>
          </div>
          <div className="bg-dark p-4 rounded-xl border border-white/5 flex items-start gap-4" data-id="element-191">
            <HeartCrack className="text-terracota shrink-0 mt-1" data-id="element-192" />
            <p className="text-gray-200" data-id="element-193">
              Decís "ya fue"… pero si aparece su mensaje,{' '}
              <strong className="text-white" data-id="element-194">
                te cambia el ánimo en un segundo
              </strong>
            </p>
          </div>
          <div className="bg-dark p-4 rounded-xl border border-white/5 flex items-start gap-4" data-id="element-195">
            <AlertTriangle className="text-terracota shrink-0 mt-1" data-id="element-196" />
            <p className="text-gray-200" data-id="element-197">
              No porque no podés evitarlo, sabes que{' '}
              <strong className="text-white" data-id="element-198">no te está haciendo bien</strong>.
              Pero <strong className="text-white" data-id="element-199">igual te quedás. </strong>
            </p>
          </div>
        </div>

        <div className="text-center bg-gradient-to-r from-dark to-black border border-rosa/30 p-6 rounded-2xl mb-8" data-id="element-200">
          <p className="text-xl font-bold text-white mb-2" data-id="element-201">
            Y en algún momento pensás:{' '}
            <span className="text-rosa" data-id="element-202">"no puedo seguir así"</span>
          </p>
          <p className="text-2xl font-black text-terracota uppercase tracking-wide mb-4" data-id="element-203">
            Eso no es amor.
            <br data-id="element-204" />
            Es <strong data-id="element-205">dependencia emocional</strong>.
          </p>
          <p className="text-gray-300" data-id="element-206">
            Y mientras no cambies eso…{' '}
            <strong className="text-white" data-id="element-207">todo se va a repetir</strong>.
          </p>
          <p className="text-white font-semibold mt-2" data-id="element-208">
            No es falta de fuerza, es{' '}
            <strong className="text-rosa" data-id="element-209">
              un patrón que todavía no sabés cómo cortar
            </strong>
            .
          </p>
        </div>

        <Button data-id="element-210">QUIERO CORTAR ESTE PATRÓN</Button>
      </div>
    </section>;
}